import { Component, OnInit } from '@angular/core';
import { TranslationService } from '../../services/translation.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-language-request-modals',
  templateUrl: './language-request-modals.component.html',
  styleUrls: ['./language-request-modals.component.scss'],
  standalone: false
})
export class LanguageRequestModalsComponent  implements OnInit {
  //we'll start with a simple popup asking for the language
  // then store the fact the language was asked at least once in localstorage
  // then we'll check for how to get the other popups etc working


  constructor(
    public translationService: TranslationService,
    private modalCtrl: ModalController,
  ) { }

  ngOnInit() {
    
  }

  setLang(lang) {
    localStorage.setItem('lang', lang);
    this.translationService.setLanguage(lang);

    this.done();
  }

  async done() {
    await this.modalCtrl.dismiss();
  }
}
